/**
 * ReportModal - 报告确认弹窗组件
 * 用于导出、重置等需要确认的操作
 */
import React from 'react';
import { Modal } from 'tea-component';
import { IReportModalProps } from '../types';
import './ReportModal.scss';

export const ReportModal: React.FC<IReportModalProps> = ({
  showModal,
  modalContent,
  formatMessage,
  onClose,
}) => {
  if (!showModal || !modalContent) {
    return null;
  }

  return (
    <Modal
      className="dba-pdf-export-modal"
      caption={modalContent.caption}
      visible={true}
      onClose={onClose}
    >
      <Modal.Body>{modalContent.bodyDesc}</Modal.Body>
      <Modal.Footer>
        <button
          className="dba-pdf-export-modal-btn-confirm"
          onClick={modalContent.onClick}
        >
          {formatMessage({ id: 'dba_confirm' })}
        </button>

        {modalContent.showCancel && (
          <button
            className="dba-pdf-export-modal-btn"
            onClick={onClose}
          >
            {formatMessage({ id: 'dba_input_cancel' })}
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ReportModal;
